// Copyright © 2019-2026 Focal Systems. All rights reserved.

/** Full IANA timezone list via Intl API. Sorted alphabetically. */
export const IANA_TIMEZONES: readonly string[] = Intl.supportedValuesOf("timeZone");

export const TIMEZONE_OPTIONS: readonly { label: string; value: string }[] = IANA_TIMEZONES.map((tz) => ({
  label: tz,
  value: tz,
}));
